/*
  BS Cart Upsell — v4
  The upsell HTML is rendered server-side in cart-drawer.liquid (Liquid).
  This script only handles the "Add Free" button click + cart refresh.
*/
window.BsUpsell = {
  add: function (variantId, btn) {
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        /* Ask Dawn to re-render the cart drawer with updated contents */
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          /* Dawn exposes this method to refresh the drawer */
          if (typeof cartDrawer.renderContents === 'function') {
            var fakeEvent = { target: { closest: function() { return null; }, getAttribute: function() { return null; } } };
            cartDrawer.renderContents(fakeEvent);
          } else {
            /* Fallback: reload the cart drawer section via fetch */
            fetch('/?section_id=cart-drawer')
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var newItems = doc.querySelector('cart-drawer-items');
                var currentItems = document.querySelector('cart-drawer-items');
                if (newItems && currentItems) {
                  currentItems.innerHTML = newItems.innerHTML;
                }
                /* Update totals */
                var newFooter = doc.querySelector('.cart-drawer__footer');
                var currentFooter = document.querySelector('.cart-drawer__footer');
                if (newFooter && currentFooter) {
                  currentFooter.innerHTML = newFooter.innerHTML;
                }
                /* Re-render the upsell wrap area */
                var newUpsell = doc.querySelector('.bs-upsell-wrap');
                var currentUpsell = document.querySelector('.bs-upsell-wrap');
                if (currentUpsell) {
                  if (newUpsell) {
                    currentUpsell.outerHTML = newUpsell.outerHTML;
                  } else {
                    currentUpsell.remove();
                  }
                }
              });
          }
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add Free';
      });
  }
};
